import { Image as Image$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Image = createRemoteReactComponent(Image$1);

export { Image };
